import { LAST_ORDER_GET_REQUEST } from 'yoda-checkout-components/lib/actionTypes/PlaceOrderActionTypes';

export const getOrderDetails = (payload) => ({
    type: LAST_ORDER_GET_REQUEST,
    payload,
});

export default getOrderDetails;
